import React, { useState } from 'react'

import { 
    Box,
    Typography,
    Paper,
    Container,
    Grid,
    TextField,
    styled,
    Card
} from '@mui/material';

import {
  LoadingButton
} from '@mui/lab';

import { Formik, Form } from 'formik';

import CommonBreadcumbs from '../common/CommonBreadcumbs';
import CommonSectionHeader from '../common/CommonSectionHeader';

import { useAuth } from '../../hooks/api/useAuth';
import { useSystemPrompt } from '../../hooks/useSystemPrompt';
import { useAuthAccess } from '../../hooks/useAuthAccess';
import { routeTypes } from '../../hooks/useSystemRoutes';
import { useSystemHead, headTitles } from '../../hooks/useSystemHead';
import { useTranslations } from "../../hooks/useTranslations";

import { validationSchema, initialValues } from '../../schema/users/passwordSchema'

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));

export default function UpdatePassword({
    routeType
}) {

    const { t } = useTranslations({ ns: ["@account", "common"] })

    const { promptMessage } = useSystemPrompt();
    const { isLoading, changePassword }  = useAuth();
    const { authData } = useAuthAccess();
    const { getHtmlHead } = useSystemHead(routeType)

    const [ id, setId ] = useState(authData?.userId)

    const onSubmit = async (currentValues) => {

        try{
            
            const response = await changePassword({ 
                current: currentValues.passwordcurrent,
                password: currentValues.password,
                confirm: currentValues.passwordconfirm
            });

            promptMessage(true, `${response?.message}`)
                
        }catch(error){

            promptMessage(false, `Action Failed (${error?.message})`)
        }   

    }

    const RenderForm = () => {
        return(
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                enableReinitialize
            >
                
            {
                ({ values, errors, touched, handleChange, setFieldValue}) => (
                    <Form>
                        <StyledCard>
                            <Grid container spacing={1}>
                                <Grid item xs={12} sm={12} md={4} textAlign={"left"}>
                                    
                                    <CommonSectionHeader
                                        title={t('changeCredential')}
                                        subTitle={t('verifyAccountOwnership')}
                                    />
                                    
                                </Grid>
                                <Grid item xs={12} sm={12} md={8}>

                                    <Grid container spacing={1} textAlign={"left"}>
                                        <Grid item xs={12} sm={12} md={6}>
                                            <TextField
                                                margin="dense"
                                                size="small"
                                                autoFocus
                                                fullWidth
                                                name={"passwordcurrent"}
                                                label={t('currentPassword')}
                                                type="password"                                         
                                                variant="outlined"
                                                value={values.passwordcurrent}
                                                onChange={handleChange}
                                                error={touched.passwordcurrent && Boolean(errors.passwordcurrent)}
                                                helperText={touched.passwordcurrent && errors.passwordcurrent}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={6}><></></Grid>
                                        <Grid item xs={12} sm={12} md={6}>
                                            <TextField
                                                margin="dense"
                                                size="small"
                                                fullWidth
                                                name={"password"}
                                                label={t('password')}
                                                type="password"                                         
                                                variant="outlined"
                                                value={values.password}
                                                onChange={handleChange}
                                                error={touched.password && Boolean(errors.password)}
                                                helperText={touched.password && errors.password}
                                            />
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={6}>
                                            <TextField
                                                margin="dense"
                                                size="small"
                                                fullWidth
                                                name={"passwordconfirm"}
                                                label={t('confirmPassword')}
                                                type="password"                                         
                                                variant="outlined"
                                                value={values.passwordconfirm}
                                                onChange={handleChange}
                                                error={touched.passwordconfirm && Boolean(errors.passwordconfirm)}
                                                helperText={touched.passwordconfirm && errors.passwordconfirm}
                                            />
                                        </Grid>
                                    </Grid>
                                </Grid>
                                
                            </Grid>
                        </StyledCard>
                        <Grid container spacing={1} sx={{ pl: 2, pr: 2}}>
                            <Grid item md={12} textAlign={"right"}>
                                <LoadingButton
                                    type="submit"
                                    // fullWidth
                                    variant="contained"
                                    sx={{ 
                                        mt: 3,
                                        mb: 2
                                    }}
                                    loading={isLoading}
                                >
                                    {t('saveChanges')}
                                </LoadingButton>
                            </Grid>
                        </Grid>
                    </Form>
                )
            }
            </Formik>
        )
    }

    return (
        <Box>
            {  
                getHtmlHead({ routeType, title: headTitles.password })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t('changePassword')}
                breadcrumbs={[
                    {
                        displayText: t('changePassword'),
                        props: {
                            // underline: "hover",
                            // href: "/"
                        }
                    }
                ]}
            />

            { RenderForm() }

        </Box>
    )
}
